const api = import.meta.env.VITE_API;

const apiAddress = import.meta.env.PROD ? window.location.origin + '/api' : api;

export const SERVER_ADDRESSES = {
  API: apiAddress,
};

export const SERVER_APPLICATION_NAMES = {
  API: 'API',
};
